import { UniqueCollection, GAME_ENGINE, PROGRAMMING_LANGUAGE, PROJECT_PLATFORM, PROJECT_ROLE, PROJECT_TAG, PROJECT_TYPE, TEAMMATE, Teammate, TeammateLink, Project } from "./classes";
import Accent from "@/components/Accent/Accent.vue";
import { h } from "vue";

function getKylianDekker(roles: PROJECT_ROLE[]): Teammate
{
	return new Teammate(
		TEAMMATE.KYLIAN_DEKKER,
		roles,
		new TeammateLink(
			"https://www.kyliandekker.com",
			"https://github.com/kyliandekker",
			"https://www.linkedin.com/in/kyliandekker",
			"",
			""
		)
	)
}

function getKayminSambrano(roles: PROJECT_ROLE[]): Teammate
{
	return new Teammate(
		TEAMMATE.KAYMIN_SAMBRANO,
		roles,
		new TeammateLink(
			"",
			"",
			"",
			"",
			"",
		)
	)
}

function getJustinKujawa(roles: PROJECT_ROLE[]): Teammate {
	return new Teammate(
		TEAMMATE.JUSTIN_KUJAWA,
		roles,
		new TeammateLink("https://jkujawa.com/", "https://github.com/Contingencyy", "https://www.linkedin.com/in/justin-kujawa-37094718a", "", "")
	);
}

function getSamBoots(roles: PROJECT_ROLE[]): Teammate {
	return new Teammate(
		TEAMMATE.SAM_BOOTS,
		roles,
		new TeammateLink("https://samboots.github.io/portfolio/", "https://github.com/SamBoots", "https://www.linkedin.com/in/sam-boots-7b256b15", "", "")
	);
}

function getLyubomirKostadinov(roles: PROJECT_ROLE[]): Teammate {
	return new Teammate(
		TEAMMATE.LYUBOMIR_KOSTADINOV,
		roles,
		new TeammateLink("", "https://github.com/lyubokostadinov", "https://www.linkedin.com/in/lyubomir-kostadinov-b25062229", "", "")
	);
}

function getSlavaTakrovskij(roles: PROJECT_ROLE[]): Teammate {
	return new Teammate(
		TEAMMATE.SLAVA_TAKROVSKIJ,
		roles,
		new TeammateLink("", "", "https://www.linkedin.com/in/slava-takrovskij-21b7691b", "", "")
	);
}

function getMartijnVahl(roles: PROJECT_ROLE[]): Teammate {
	return new Teammate(
		TEAMMATE.MARTIJN_VAHL,
		roles,
		new TeammateLink("https://martijnvahl.com/", "", "https://www.linkedin.com/in/martijnvahl/", "", "")
	);
}

function getStanVogels(roles: PROJECT_ROLE[]): Teammate {
	return new Teammate(
		TEAMMATE.STAN_VOGELS,
		roles,
		new TeammateLink("https://stanvogels.com/", "https://github.com/Reemhi2122", "https://www.linkedin.com/in/stanvogels/", "", "")
	);
}

function getLexRoovers(roles: PROJECT_ROLE[]): Teammate {
	return new Teammate(
		TEAMMATE.LEX_ROOVERS,
		roles,
		new TeammateLink("https://lexroovers.com/", "https://github.com/Flashcaptain", "https://www.linkedin.com/in/lex-roovers-aa9405155", "", "")
	);
}

function getMariaLoannou(roles: PROJECT_ROLE[]): Teammate {
	return new Teammate(
		TEAMMATE.MARIA_LOANNOU,
		roles,
		new TeammateLink("", "", "https://www.linkedin.com/in/maria-ioannou-0898841b8", "https://www.artstation.com/lamci", "")
	);
}

function getRembrandtVanLeeuwen(roles: PROJECT_ROLE[]): Teammate {
	return new Teammate(
		TEAMMATE.REMBRANDT_VAN_LEEUWEN,
		roles,
		new TeammateLink("", "", "https://www.linkedin.com/in/rembrandt-van-leeuwen-968801a1", "https://www.artstation.com/clockweiz", "")
	);
}

function getWesleyCats(roles: PROJECT_ROLE[]): Teammate {
	return new Teammate(
		TEAMMATE.WESLEY_CATS,
		roles,
		new TeammateLink("https://wesleycats.com/", "", "https://www.linkedin.com/in/wesley-cats-games/", "", "")
	);
}

function getLucaYavuzok(roles: PROJECT_ROLE[]): Teammate {
	return new Teammate(
		TEAMMATE.LUCA_YAVUZOK,
		roles,
		new TeammateLink("https://lucayavuzok.com/", "", "https://www.linkedin.com/in/luca-yavuzok-04067815b/", "", "")
	);
}

// function getDefault(roles: PROJECT_ROLE[]): Teammate {
// 	return new Teammate(
// 		TEAMMATE.DSADAS,
// 		roles,
// 		new TeammateLink("", "", "", "", "")
// 	);
// }

export const PROJECTS: Project[] = [
	new Project(
		"Microsoft Flight Simulator 2024",
		"Climax Studios",
		"Explore the world with our largest fleet of aircraft and take simulation to new heights while pursuing your aviation career within Microsoft Flight Simulator 2024.",
		"2023-2024",
		"msfs",
		[ PROJECT_PLATFORM.WINDOWS, PROJECT_PLATFORM.STEAM, PROJECT_PLATFORM.XBOX, PROJECT_PLATFORM.PS5 ],
		PROJECT_TYPE.VIDEO_GAME,
		PROGRAMMING_LANGUAGE.CPP,
		GAME_ENGINE.IN_HOUSE,
		new UniqueCollection<Teammate>([
			getKylianDekker(
				[
					PROJECT_ROLE.GAMEPLAY_PROGRAMMER,
					PROJECT_ROLE.TOOLS_PROGRAMMER,
					PROJECT_ROLE.UI_PROGRAMMER,
				]
			)
		]),
		[
			() => h(
				"span",
				null,
				[
					"Engineered and enhanced ",
					h(Accent, null, { default: () => "core functionality" }),
					" and game mechanics within a ",
					h(Accent, null, { default: () => "proprietary engine" }),
					" using C++."
				]
			),
			() => h(
				"span",
				null,
				[
					"Contributed to the ",
					h(Accent, null, { default: () => "RENO" }),
					" and ",
					h(Accent, null, { default: () => "Red Bull" }),
					" game modes by ",
					h(Accent, null, { default: () => "implementing" }),
					" new maps and gameplay rules."
				]
			),
			() => h(
				"span",
				null,
				[
					h(Accent, null, { default: () => "Designed" }),
					" and ",
					h(Accent, null, { default: () => "implemented" }),
					" a ",
					h(Accent, null, { default: () => "custom internal tool" }),
					" that significantly streamlined workflows and ",
					h(Accent, null, { default: () => "accelerated overall development for the entire team" }),
					"."
				]
			),
			() => h(
				"span",
				null,
				[
					"Developed responsive front-end UI systems using TypeScript.",
				]
			),
			() => h(
				"span",
				null,
				[
					"Stubbed and implemented methods for .",
					h(Accent, null, { default: () => "Playstation 5" }),
					".",
				]
			),
			() => h(
				"span",
				null,
				[
					"Utilized industry-standard tools, including ",
					h(Accent, null, { default: () => "Coherent UI" }),
					" and ",
					h(Accent, null, { default: () => "Perforce" }),
					".",
				]
			),
		],
		[
			"How big and complex a team is when working on a AAA project.",
			"How to navigate my way around a big unfamiliar codebase by using various tools such as ripgrep, Everything and handy visual studio shortcuts.",
			"How important development tools are when working and debugging in projects of this scale.",
			"Working and communicating with other companies when work is shared across different studios.",
		],
		[ PROJECT_TAG.SINGLEPLAYER, PROJECT_TAG.MULTIPLAYER, PROJECT_TAG.ART_3D, PROJECT_TAG.SIMULATION, PROJECT_TAG.PORTING ],
		"#48C7F0"
	),
	new Project(
		"Arma 4",
		"Bohemia Interactive",
		"Due to NDA, I am currently unable to say much about my work in Arma 4, but here are a few bullet points of my general activities.",
		"2026-20XX",
		"arma4",
		[ PROJECT_PLATFORM.WINDOWS, PROJECT_PLATFORM.STEAM, PROJECT_PLATFORM.XBOX, PROJECT_PLATFORM.PS5 ],
		PROJECT_TYPE.VIDEO_GAME,
		PROGRAMMING_LANGUAGE.CPP,
		GAME_ENGINE.ENFUSION,
		new UniqueCollection<Teammate>([
			getKylianDekker(
				[
					PROJECT_ROLE.GAMEPLAY_PROGRAMMER,
					PROJECT_ROLE.TECHNICAL_DESIGNER,
					PROJECT_ROLE.SCRIPTER,
				]
			)
		]),
		[
			() => h(
				"span",
				null,
				[
					"Designed and developed ",
					h(Accent, null, { default: () => "AI frameworks" }),
					" in a ",
					h(Accent, null, { default: () => "proprietary engine" }),
					"."
				]
			),
			() => h(
				"span",
				null,
				[
					"Designed and created ",
					h(Accent, null, { default: () => "architecture" }),
					" that supports ",
					h(Accent, null, { default: () => "modding" }),
					", ",
					h(Accent, null, { default: () => "community-driven content" }),
					" and ",
					h(Accent, null, { default: () => "multiplayer features" }),
				]
			),
			() => h(
				"span",
				null,
				[
					h(Accent, null, { default: () => "Feature Owner" }),
					" of the ",
					h(Accent, null, { default: () => "Text Chat system" }),
					".",
				]
			),
			() => h(
				"span",
				null,
				[
					"Utilized industry-standard tools, including ",
					h(Accent, null, { default: () => "Jira" }),
					", ",
					h(Accent, null, { default: () => "Confluence" }),
					" and ",
					h(Accent, null, { default: () => "SVN" }),
					".",
				]
			),
		],
		[
			"Onboarded senior-level and mid-level programmers and technical designers.",
			"Took ownership of tasks and organized and scheduled meetings as owner of several features.",
		],
		[ PROJECT_TAG.SINGLEPLAYER, PROJECT_TAG.MULTIPLAYER, PROJECT_TAG.ART_3D ],
		"#8E4742"
	),
	new Project(
		"Unannounced Project in DayZ Series",
		"Bohemia Interactive",
		"Due to NDA, I am currently unable to say much about what project I have worked on, but here are a few bullet points of my general activities.",
		"2025-20XX",
		"dayz",
		[ PROJECT_PLATFORM.WINDOWS, PROJECT_PLATFORM.STEAM, PROJECT_PLATFORM.XBOX, PROJECT_PLATFORM.PS5 ],
		PROJECT_TYPE.VIDEO_GAME,
		PROGRAMMING_LANGUAGE.CPP,
		GAME_ENGINE.ENFUSION,
		new UniqueCollection<Teammate>([
			getKylianDekker(
				[
					PROJECT_ROLE.GAMEPLAY_PROGRAMMER,
					PROJECT_ROLE.TECHNICAL_DESIGNER,
					PROJECT_ROLE.SCRIPTER,
				]
			)
		]),
		[
			() => h(
				"span",
				null,
				[
					"Worked in a ",
					h(Accent, null, { default: () => "proprietary engine" }),
					" using ",
					h(Accent, null, { default: () => "C++" }),
					"."
				]
			),
			() => h(
				"span",
				null,
				[
					"Worked on this project from its ",
					h(Accent, null, { default: () => "conception" }),
					"."
				]
			),
			() => h(
				"span",
				null,
				[
					"Designed and created ",
					h(Accent, null, { default: () => "architecture" }),
					" that supports ",
					h(Accent, null, { default: () => "modding" }),
					", ",
					h(Accent, null, { default: () => "community-driven content" }),
					" and ",
					h(Accent, null, { default: () => "multiplayer features" }),
				]
			),
		],
		[
			
		],
		[ PROJECT_TAG.SINGLEPLAYER, PROJECT_TAG.MULTIPLAYER ],
		"#AC0C0C"
	),
	new Project(
		"Gallus Engine (Custom Engine)",
		"",
		"A pet project of mine used for learning more about graphics, engine architecture, UI, audio and everything else. NOTE: This is a WIP and it is by no means finished. I work on this in my freetime.",
		"2024-2026",
		"gallusengine",
		[ PROJECT_PLATFORM.WINDOWS, PROJECT_PLATFORM.VR, PROJECT_PLATFORM.GITHUB ],
		PROJECT_TYPE.GAME_ENGINE,
		PROGRAMMING_LANGUAGE.CPP,
		GAME_ENGINE.GALLUS_ENGINE,
		new UniqueCollection<Teammate>([
			getKylianDekker(
				[
					PROJECT_ROLE.ENGINE_PROGRAMMER,
					PROJECT_ROLE.AUDIO_PROGRAMMER,
					PROJECT_ROLE.GRAPHICS_PROGRAMMER,
					PROJECT_ROLE.UI_PROGRAMMER,
					PROJECT_ROLE.GAMEPLAY_PROGRAMMER,
				]
			)
		]),
		[
			() => h(
				"span",
				null,
				[
					"Designed and implemented ",
					h(Accent, null, { default: () => "all UI and features" }),
					" such as the file explorer, inspector, scene window and all others using ",
					h(Accent, null, { default: () => "ImGui" }),
					"."
				]
			),
			() => h(
				"span",
				null,
				[
					"Developed a ",
					h(Accent, null, { default: () => "NodeJS tool" }),
					" that lets me ",
					h(Accent, null, { default: () => "embed fonts directly into the engine" }),
					" and ",
					h(Accent, null, { default: () => "dynamically add or remove icons" }),
					"."
				]
			),
			() => h(
				"span",
				null,
				[
					"Did .",
					h(Accent, null, { default: () => "all the graphics work" }),
					" for the engine using ",
					h(Accent, null, { default: () => "DirectX 12" }),
					"."
				]
			),
			() => h(
				"span",
				null,
				[
					"Created all systems, including but not limited to: ",
					h(Accent, null, { default: () => "ECS" }),
					", ",
					h(Accent, null, { default: () => "Input System" }),
					", ",
					h(Accent, null, { default: () => "Animation System" }),
					", ",
					h(Accent, null, { default: () => "Logger" }),
					", ",
					h(Accent, null, { default: () => "File System" }),
					", etc.",
				]
			),
		],
		[
			"Learned the basics of DirectX12, like resource management, render textures, root signatures, pipelines, etc.",
			"Learned more about creating custom tools that help accelerate the development of a project like this.",
		],
		[ PROJECT_TAG.CUSTOM_ENGINE ],
		"#B55214"
	),
	new Project(
		"Gudenuff Engine (Custom Engine) + Game",
		"",
		"A game engine for a 2D roguelike dungeon crawlers with rhythm-based mechanics. Can compile games for PC and PS4. Used to make the game Setsuko: Drums of Harmony.",
		"2023-2024",
		"gudenuffengine",
		[ PROJECT_PLATFORM.WINDOWS, PROJECT_PLATFORM.PS4, PROJECT_PLATFORM.ITCH ],
		PROJECT_TYPE.VIDEO_GAME,
		PROGRAMMING_LANGUAGE.CPP,
		GAME_ENGINE.GUDENUFF_ENGINE,
		new UniqueCollection<Teammate>([
			getKylianDekker(
				[
					PROJECT_ROLE.GAMEPLAY_PROGRAMMER,
					PROJECT_ROLE.AUDIO_PROGRAMMER,
					PROJECT_ROLE.TOOLS_PROGRAMMER,
					PROJECT_ROLE.ENGINE_PROGRAMMER
				]
			),
			getSlavaTakrovskij(
				[
					PROJECT_ROLE.TOOLS_PROGRAMMER,
					PROJECT_ROLE.GAMEPLAY_PROGRAMMER,
					PROJECT_ROLE.PRODUCT_OWNER,
				]
			),
			getJustinKujawa(
				[
					PROJECT_ROLE.GRAPHICS_PROGRAMMER,
				]
			),
			getSamBoots(
				[
					PROJECT_ROLE.GRAPHICS_PROGRAMMER,
					PROJECT_ROLE.PROGRAMMING_LEAD,
				]
			),
			getLyubomirKostadinov(
				[
					PROJECT_ROLE.GRAPHICS_PROGRAMMER,
				]
			),
			getMartijnVahl(
				[
					PROJECT_ROLE.GAMEPLAY_PROGRAMMER,
				]
			),
			getStanVogels(
				[
					PROJECT_ROLE.ENGINE_PROGRAMMER,
				]
			),
			getLexRoovers(
				[
					PROJECT_ROLE.GAMEPLAY_PROGRAMMER,
					PROJECT_ROLE.TOOLS_PROGRAMMER,
				]
			),
			getMariaLoannou(
				[
					PROJECT_ROLE.ARTIST_2D,
				]
			),
			getRembrandtVanLeeuwen(
				[
					PROJECT_ROLE.ARTIST_2D,
				]
			),
			getWesleyCats(
				[
					PROJECT_ROLE.PRODUCER,
				]
			),
			getLucaYavuzok(
				[
					PROJECT_ROLE.GAME_DESIGNER,
				]
			),
		]),
		[
			() => h(
				"span",
				null,
				[
					"Designed and implemented the core gameplay mechanic of ",
					h(Accent, null, { default: () => "rhythm-based movement synchronized with a changing BPM" }),
					"."
				]
			),
			() => h(
				"span",
				null,
				[
					"Designed and implemented ",
					h(Accent, null, { default: () => "all UI and features" }),
					" such as the file explorer, UI editor, level creator and all audio tools using ",
					h(Accent, null, { default: () => "ImGui" }),
					"."
				]
			),
			() => h(
				"span",
				null,
				[
					"Created the ",
					h(Accent, null, { default: () => "Resource Management System" }),
					" across both ",
					h(Accent, null, { default: () => "Windows" }),
					" and ",
					h(Accent, null, { default: () => "PS4" }),
					".",
				]
			),
			() => h(
				"span",
				null,
				[
					"Composed the original soundtrack and designed all sound effects.",
				]
			),
		],
		[
			"How to create my own game engine, including the planning process.",
			"How to create systems based on feedback from designers and gameplay programmers.",
		],
		[ PROJECT_TAG.SINGLEPLAYER, PROJECT_TAG.CUSTOM_ENGINE, PROJECT_TAG.PS4, PROJECT_TAG.RHYTHM_BASED ],
		"#4761AB"
	),
	new Project(
		"CoopScoop",
		"",
		"A chicken virus spreads rapidly across the country and some of your chickens are infected and you need to take care of the sick chickens. You need to wash them, feed them and take good care of them to maintain a stable farm. Can you manage all those chickens?",
		"2024-2025",
		"coopscoop",
		[ PROJECT_PLATFORM.WINDOWS, PROJECT_PLATFORM.VR, PROJECT_PLATFORM.STEAM ],
		PROJECT_TYPE.VIDEO_GAME,
		PROGRAMMING_LANGUAGE.CS,
		GAME_ENGINE.UNITY_ENGINE,
		new UniqueCollection<Teammate>([
			getKylianDekker(
				[
					PROJECT_ROLE.GAMEPLAY_PROGRAMMER,
					PROJECT_ROLE.PROJECT_LEADER,
					PROJECT_ROLE.COMPOSER,
					PROJECT_ROLE.GAME_DESIGNER,
					PROJECT_ROLE.ARTIST_3D
				]
			),
			getKayminSambrano(
				[
					PROJECT_ROLE.VOICE_ACTOR
				]
			)
		]),
		[
			() => h(
				"span",
				null,
				[
					"Designed and implemented all core gameplay elements, including ",
					h(Accent, null, { default: () => "custom VR physics systems" }),
					", ",
					h(Accent, null, { default: () => "dynamic chicken AI" }),
					", ",
					h(Accent, null, { default: () => "interactive tutorials" }),
					" and all other mechanics."
				]
			),
			() => h(
				"span",
				null,
				[
					"Developed to accelerate production, ",
					h(Accent, null, { default: () => "custom Unity tools" }),
					" to accelerate production, such as a ",
					h(Accent, null, { default: () => "subtitle editor" }),
					", ",
					h(Accent, null, { default: () => "spline generator" }),
					", ",
					h(Accent, null, { default: () => "play area editor" }),
					", and an ",
					h(Accent, null, { default: () => "audio system that" }),
					" that ",
					h(Accent, null, { default: () => "dynamically displays subtitles based on audio data position" }),
					"."
				]
			),
			() => h(
				"span",
				null,
				[
					"Composed the original soundtrack, designed sound effects, created all 3D models, and handled all additional creative and technical aspects of the game.",
				]
			),
		],
		[
			"Learned how to model in Blender.",
			"Learned how to upload a game to Steam and create a playtesting pipeline.",
		],
		[ PROJECT_TAG.SINGLEPLAYER, PROJECT_TAG.VR ],
		"rgb(223 170 44)"
	),
	new Project(
		"Audio Engine",
		"",
		"A pet project of mine used for learning more about audio and signal processing. It showcases runtime DSP, playback and audio effects.",
		"2023-2024",
		"audioengine",
		[ PROJECT_PLATFORM.WINDOWS, PROJECT_PLATFORM.GITHUB ],
		PROJECT_TYPE.GAME_ENGINE,
		PROGRAMMING_LANGUAGE.CPP,
		GAME_ENGINE.IN_HOUSE,
		new UniqueCollection<Teammate>([
			getKylianDekker(
				[
					PROJECT_ROLE.ENGINE_PROGRAMMER,
					PROJECT_ROLE.AUDIO_PROGRAMMER,
					PROJECT_ROLE.UI_PROGRAMMER,
				]
			)
		]),
		[
			() => h(
				"span",
				null,
				[
					"Wrote an audio engine supporting ",
					h(Accent, null, { default: () => "playback" }),
					", ",
					h(Accent, null, { default: () => "mixing" }),
					" and ",
					h(Accent, null, { default: () => "basic DSP" }),
					" functionality."
				]
			),
		],
		[
			"Learned about audio signal processing, multithreading, and applying mathematical concepts to real-time audio systems.",
		],
		[ PROJECT_TAG.TOOL, PROJECT_TAG.SHOWCASE ],
		"#FFCC2E"
	),
	new Project(
		"In Sheeps’s Clothing",
		"",
		"The political party for animal rights has been taken over by animals and has arranged a meeting about their possibly evil plans for the future. You’ll be disguised as a sheep and you’ll attend this meeting. Do not do anything suspicious, though! Who knows what they’ll do if they find out that you’re spying on them?",
		"2024",
		"insheepsclothing",
		[ PROJECT_PLATFORM.WINDOWS, PROJECT_PLATFORM.VR ],
		PROJECT_TYPE.VIDEO_GAME,
		PROGRAMMING_LANGUAGE.CS,
		GAME_ENGINE.UNITY_ENGINE,
		new UniqueCollection<Teammate>([
			getKylianDekker(
				[
					PROJECT_ROLE.GAMEPLAY_PROGRAMMER,
					PROJECT_ROLE.COMPOSER,
					PROJECT_ROLE.SOUND_DESIGNER,
					PROJECT_ROLE.GAME_DESIGNER,
					PROJECT_ROLE.ARTIST_3D
				]
			),
			getStanVogels(
				[
					PROJECT_ROLE.GAMEPLAY_PROGRAMMER,
					PROJECT_ROLE.GAME_DESIGNER,
				]
			),
			getKayminSambrano(
				[
					PROJECT_ROLE.VOICE_ACTOR
				]
			),
		]),
		[
			() => h(
				"span",
				null,
				[
					"Designed and implemented several key gameplay elements, including VR physics and camera mechanics.",
				]
			),
			() => h(
				"span",
				null,
				[
					"Composed the original soundtrack, designed sound effects and created all 3D models."
				]
			),
		],
		[
			"Make shared libraries for VR projects and make them dynamic enough where specific game mechanics can be changed."
		],
		[ PROJECT_TAG.SINGLEPLAYER, PROJECT_TAG.VR ],
		"#5E5D3E"
	)
];

PROJECTS[0].steamLink = "https://store.steampowered.com/app/2537590/Microsoft_Flight_Simulator_2024/";
PROJECTS[5].steamLink = "https://store.steampowered.com/app/2672620/CoopScoop/";
PROJECTS[4].itchLink = "https://buas.itch.io/gudenuff-drumsofharmony";
PROJECTS[3].gitHubLink = "https://github.com/kyliandekker/gallus-3D";
PROJECTS[6].gitHubLink = "https://github.com/kyliandekker/audio-showcase/";

const CURRENT_DATE: Date = new Date();
const C_PROGRAMMING_YEAR = 2016;
const PROGRAMMING_YEAR_CPP = 2021;
const PROGRAMMING_YEAR_AAA = 2023;
const BIRTHDAY: Date = new Date("January 25, 2000 00:00:00");

export const CURRENT_YEAR = () => {
	return CURRENT_DATE.getFullYear();
};

export const PROGRAMMING_YEAR = () => {
	return C_PROGRAMMING_YEAR;
};

export const PROGRAMMING_EXPERIENCE = () => {
	return CURRENT_YEAR() - C_PROGRAMMING_YEAR;
};

export const PROGRAMMING_EXPERIENCE_CPP = () => {
	return CURRENT_YEAR() - PROGRAMMING_YEAR_CPP;
};

export const PROGRAMMING_EXPERIENCE_AAA = () => {
	return CURRENT_YEAR() - PROGRAMMING_YEAR_AAA;
};

export const AGE = () => {
	const today = new Date();
	let age = today.getFullYear() - BIRTHDAY.getFullYear();
	const m = today.getMonth() - BIRTHDAY.getMonth();
	if (m < 0 || (m === 0 && today.getDate() < BIRTHDAY.getDate())) {
		age--;
	}
	return age; // Return an object with the calculated age
};